<div class="form-check ms-4">
  <app-checkbox
    *ngFor="let checkbox of checkboxes"
    [controlName]="checkbox.name"
    [control]="$any(checkbox.control)"
    [assistantServiceEnabled]="appConfig.isAssistantAvailable"
    [saveLastFocusedEnabled]="true"
  >
    <app-checkbox-group-texts class="app-label" [textKey]="getLabelTextKey(checkbox.name)" />
    <div class="assistant-text">
      <app-checkbox-group-texts [textKey]="getAssistanceTextKey(checkbox.name)" />
    </div>
  </app-checkbox>
</div>
